<div class="card h-100">
  <slot
    gpeiSelectorBasedSlot
    [slot]="slot"
    name="card-header"
    select="gpei-card-header">
  </slot>
  <div class="card-body">
    <slot #slot></slot>
  </div>
</div>
